import Marquee from "react-fast-marquee";
import { MARQUEE_TOPICS } from "../../lib/content";

export const TopicsMarquee = () => (
  <div data-testid="topics-marquee" className="py-10 border-y border-[rgba(28,22,16,0.12)] bg-[#eceae4]">
    <Marquee speed={35} gradient gradientColor="#eceae4" gradientWidth={120} autoFill>
      {MARQUEE_TOPICS.map((t) => (
        <span key={t} className="flex items-center mx-10">
          <span className="font-display italic text-2xl md:text-4xl text-[#1c1610]/85">{t}</span>
          <span className="ml-20 text-[#950606] text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
